import { createElement } from "react";
import React from "react";
import { useFeliz_React__React_useProjectContext_Static } from "../hooks/UseProjectContext.fs.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { useFeliz_React__React_useInfoPanel_Static } from "../hooks/UseRouter.fs.js";
import { some, toArray, orElse } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { ofArray, map, exists, singleton, tryHead, tryFind } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { empty, singleton as singleton_1, append, delay, toList, iterate } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { ProjectPage__OnClickPreserveQuery_Z11029FF1, ProjectPage__get_HrefPreserveQuery, ProjectPage, SearchParams, InfoPanel, Feliz_Router_Router__Router_navigateQueryPath_Static_6F3B930F } from "../ClientTypes.fs.js";
import viewer_api from "@sketchfab/viewer-api";
import { createObj, equals } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { join } from "../fable_modules/fable-library-js.4.24.0/String.js";
import "./ModelViewer.scss";


export function ModelViewer(modelViewerInputProps) {
    let elems, children;
    const initialModelId = modelViewerInputProps.initialModelId;
    const projectId = modelViewerInputProps.projectId;
    const projectContext = useFeliz_React__React_useProjectContext_Static();
    const ref = reactApi.useRef(undefined);
    const infoPanelOpt = useFeliz_React__React_useInfoPanel_Static();
    const patternInput = reactApi.useState(undefined);
    const apiOpt = patternInput[0];
    let patternInput_1;
    const initial_1 = orElse(tryFind((m) => (m.SketchfabId === initialModelId), projectContext.Config.Models), tryHead(projectContext.Config.Models));
    patternInput_1 = reactApi.useState(initial_1);
    const setCurrentModel = patternInput_1[1];
    const currentModelOpt = patternInput_1[0];
    const dependencies = [currentModelOpt];
    reactApi.useEffect(() => {
        if (currentModelOpt != null) {
            const model = currentModelOpt;
            const init = {
                autostart: 1,
                success: (api_2) => {
                    api_2.start();
                    api_2.addEventListener("viewerready", () => {
                        const api_1 = api_2;
                        patternInput[1](api_1);
                        api_1.getAnnotationList((err, annotations) => {
                            if (err == null) {
                                api_1.addEventListener("annotationSelect", (index) => {
                                    iterate((a_1) => {
                                        Feliz_Router_Router__Router_navigateQueryPath_Static_6F3B930F(singleton(new SearchParams(4, [new InfoPanel(1, [a_1.Id, a_1.Type])])), false);
                                    }, toArray(tryFind((a) => (a.AnnotationIndex === index), model.SketchFabAnnotations)));
                                });
                            }
                            else {
                                console.error(some("Couldn\'t get annotations from sketchfab"), err);
                            }
                        });
                    });
                },
                ui_animations: 0,
                ui_infos: 0,
            };
            const api_3 = new viewer_api(ref.current);
            api_3.init(model.SketchfabId, init);
        }
    }, dependencies);
    const dependencies_2 = [infoPanelOpt, projectContext.Config.Models];
    reactApi.useEffect(() => {
        if (infoPanelOpt != null) {
            const infoPanel = infoPanelOpt;
            if (infoPanel.tag === 1) {
                iterate((arg) => {
                    setCurrentModel(arg);
                }, toArray(tryFind((m_1) => exists((a_2) => {
                    if (a_2.Id === infoPanel.fields[0]) {
                        return equals(a_2.Type, infoPanel.fields[1]);
                    }
                    else {
                        return false;
                    }
                }, m_1.SketchFabAnnotations), projectContext.Config.Models)));
            }
        }
    }, dependencies_2);
    const dependencies_4 = [initialModelId];
    reactApi.useEffect(() => {
        iterate((arg_1) => {
            setCurrentModel(arg_1);
        }, toArray(tryFind((m_2) => (m_2.SketchfabId === initialModelId), projectContext.Config.Models)));
    }, dependencies_4);
    const dependencies_6 = [apiOpt, infoPanelOpt, currentModelOpt];
    reactApi.useEffect(() => {
        let matchResult, api_4, entityId_1, entityType_1, model_1;
        if (apiOpt != null) {
            if (infoPanelOpt != null) {
                if (infoPanelOpt.tag === 1) {
                    if (currentModelOpt != null) {
                        matchResult = 0;
                        api_4 = apiOpt;
                        entityId_1 = infoPanelOpt.fields[0];
                        entityType_1 = infoPanelOpt.fields[1];
                        model_1 = currentModelOpt;
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                iterate((a_4) => {
                    const arg_3 = {
                        preventCameraAnimation: false,
                        preventCameraMove: false,
                    };
                    api_4.gotoAnnotation(a_4.AnnotationIndex, arg_3);
                }, toArray(tryFind((a_3) => {
                    if (a_3.Id === entityId_1) {
                        return equals(a_3.Type, entityType_1);
                    }
                    else {
                        return false;
                    }
                }, model_1.SketchFabAnnotations)));
                break;
            }
            case 1: {
                break;
            }
        }
    }, dependencies_6);
    if (currentModelOpt != null) {
        const currentModel = currentModelOpt;
        return createElement("div", createObj(ofArray([["className", "model-viewer-container"], (elems = [createElement("div", createObj(Helpers_combineClasses("tabs", ofArray([["className", "is-centered"], ["className", "is-boxed"], ["children", (children = map((model_2) => {
            const page = new ProjectPage(4, [projectId, model_2.SketchfabId]);
            return createElement("li", createObj(toList(delay(() => append((model_2.SketchfabId === currentModel.SketchfabId) ? singleton_1(["className", "is-active"]) : empty(), delay(() => singleton_1(["children", createElement("a", {
                href: ProjectPage__get_HrefPreserveQuery(page),
                onClick: (e) => {
                    ProjectPage__OnClickPreserveQuery_Z11029FF1(page, e);
                },
                children: model_2.Name,
            })])))))));
        }, projectContext.Config.Models), createElement("ul", {
            children: reactApi.Children.toArray(Array.from(children)),
        }))]])))), createElement("iframe", {
            className: "model-viewer",
            title: currentModel.Name,
            sandbox: join(" ", ["allow-scripts", "allow-same-origin", "allow-popups", "allow-forms"]),
            allow: "autoplay",
            allow: "fullscreen",
            ref: ref,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }
    else {
        return "No Models in project";
    }
}

